// const lsSetting = JSON.parse(localStorage.getItem('setting')) || {}

const settings = {
  state: {
    hospitalName: '',

    distance: 0.2,

    rowValue: 50,
    rowScale: 1,
    ratio: 1,

    isShowHospitalName: true,
  },
  mutations: {
    updateSettings: (state, valvue) => {
      Object.assign(state, valvue)
      localStorage.setItem('setting', JSON.stringify(state))
    },
  },
  actions: {}
}
export default settings
